var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cmp-totals" }, [
    _c("div", { staticClass: "h3" }, [
      _vm._v(_vm._s(_vm.$translate("Ceres::Template.basketSum")))
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "component-loading with-icon refreshing",
        class: { "is-loading": _vm.isBasketLoading }
      },
      [
        _c(
          "dl",
          [
            _vm._t("before-item-sum"),
            _vm._v(" "),
            _vm.visibleFields.includes("basketValueNet")
              ? [
                  _c(
                    "dt",
                    { class: { "font-weight-bold": _vm.showNetPrices } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.basketValue")
                          ) +
                          " " +
                          _vm._s(_vm.$translate("Ceres::Template.basketNet")) +
                          "\n                "
                      )
                    ]
                  ),
                  _c(
                    "dd",
                    {
                      class: { "font-weight-bold": _vm.showNetPrices },
                      attrs: { "data-testing": "item-sum-net" }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm._f("currency")(
                              _vm.calculateBaseValue(
                                _vm.basket.itemSumNet,
                                _vm.basket.basketRebate
                              )
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleFields.includes("basketValueGross")
              ? [
                  _c(
                    "dt",
                    { class: { "font-weight-bold": !_vm.showNetPrices } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.basketValue")
                          ) +
                          " " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.basketGross")
                          ) +
                          "\n                "
                      )
                    ]
                  ),
                  _c(
                    "dd",
                    {
                      class: { "font-weight-bold": !_vm.showNetPrices },
                      attrs: { "data-testing": "item-sum" }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm._f("currency")(
                              _vm.calculateBaseValue(
                                _vm.basket.itemSum,
                                _vm.basket.basketRebate
                              )
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleFields.includes("rebate") && _vm.basket.basketRebate
              ? [
                  _c("dt", { staticClass: "rebate-hint" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$translate("Ceres::Template.basketRebate")) +
                        "\n                "
                    )
                  ]),
                  !_vm.showNetPrices
                    ? _c("dd", { staticClass: "rebate-hint" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$translate("Ceres::Template.basketRebateSign")
                            ) +
                            _vm._s(
                              _vm._f("currency")(
                                _vm.calculateBaseValue(
                                  _vm.basket.itemSum,
                                  _vm.basket.basketRebate
                                ) - _vm.basket.itemSum
                              )
                            ) +
                            "\n                "
                        )
                      ])
                    : _c("dd", { staticClass: "rebate-hint" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$translate("Ceres::Template.basketRebateSign")
                            ) +
                            _vm._s(
                              _vm._f("currency")(
                                _vm.calculateBaseValue(
                                  _vm.basket.itemSumNet,
                                  _vm.basket.basketRebate
                                ) - _vm.basket.itemSumNet
                              )
                            ) +
                            "\n                "
                        )
                      ]),
                  _vm._v(" "),
                  _c(
                    "dt",
                    { class: { "font-weight-bold": _vm.showNetPrices } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.basketSubTotal")
                          ) +
                          " " +
                          _vm._s(_vm.$translate("Ceres::Template.basketNet")) +
                          "\n                "
                      )
                    ]
                  ),
                  _c(
                    "dd",
                    { class: { "font-weight-bold": _vm.showNetPrices } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm._f("currency")(_vm.basket.itemSumNet)) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "dt",
                    { class: { "font-weight-bold": !_vm.showNetPrices } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.basketSubTotal")
                          ) +
                          " " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.basketGross")
                          ) +
                          "\n                "
                      )
                    ]
                  ),
                  _c(
                    "dd",
                    { class: { "font-weight-bold": !_vm.showNetPrices } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm._f("currency")(_vm.basket.itemSum)) +
                          "\n                "
                      )
                    ]
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm._t("after-item-sum"),
            _vm._v(" "),
            _vm._t("before-shipping-costs"),
            _vm._v(" "),
            _vm.visibleFields.includes("shippingCostsNet")
              ? [
                  _c(
                    "dt",
                    { class: { "font-weight-bold": _vm.showNetPrices } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.basketShippingCosts"
                            )
                          ) +
                          " " +
                          _vm._s(_vm.$translate("Ceres::Template.basketNet")) +
                          "\n                "
                      )
                    ]
                  ),
                  _c(
                    "dd",
                    {
                      class: { "font-weight-bold": _vm.showNetPrices },
                      attrs: { "data-testing": "shipping-amount-net" }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm._f("currency")(_vm.basket.shippingAmountNet)
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleFields.includes("shippingCostsGross")
              ? [
                  _c(
                    "dt",
                    { class: { "font-weight-bold": !_vm.showNetPrices } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.basketShippingCosts"
                            )
                          ) +
                          " " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.basketGross")
                          ) +
                          "\n                "
                      )
                    ]
                  ),
                  _c(
                    "dd",
                    {
                      class: { "font-weight-bold": !_vm.showNetPrices },
                      attrs: { "data-testing": "shipping-amount" }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm._f("currency")(_vm.basket.shippingAmount)
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm._t("after-shipping-costs"),
            _vm._v(" "),
            _vm.visibleFields.includes("promotionCoupon") &&
            _vm.basket.couponCode &&
            _vm.basket.couponCampaignType === "promotion"
              ? [
                  _c("dt", { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$translate("Ceres::Template.basketCoupon")) +
                        "\n                "
                    )
                  ]),
                  _c(
                    "dd",
                    {
                      staticClass: "font-weight-bold",
                      attrs: { "data-testing": "promotion-coupon" }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm._f("currency")(_vm.basket.couponDiscount)
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _vm._t("before-total-sum"),
            _vm._v(" "),
            _vm.visibleFields.includes("totalSumNet")
              ? [
                  _c(
                    "dt",
                    { class: { "font-weight-bold": _vm.showNetPrices } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.basketTotalSum")
                          ) +
                          " " +
                          _vm._s(_vm.$translate("Ceres::Template.basketNet")) +
                          "\n                "
                      )
                    ]
                  ),
                  _c(
                    "dd",
                    {
                      class: { "font-weight-bold": _vm.showNetPrices },
                      attrs: { "data-testing": "basket-amount-net" }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm._f("currency")(_vm.basket.basketAmountNet)
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm._t("before-vat"),
            _vm._v(" "),
            _vm._l(_vm.basket.totalVats, function(totalVat) {
              return _vm.visibleFields.includes("vats")
                ? _c("div", { staticClass: "vatTotals" }, [
                    _c("dt", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$translate("Ceres::Template.basketVAT")) +
                          " " +
                          _vm._s(totalVat.vatValue) +
                          "%\n                "
                      )
                    ]),
                    _c("dd", { attrs: { "data-testing": "vat-amount" } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm._f("currency")(totalVat.vatAmount)) +
                          "\n                "
                      )
                    ])
                  ])
                : _vm._e()
            }),
            _vm._v(" "),
            _vm._t("after-vat"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "totalSum" },
              [
                _c("hr"),
                _vm._v(" "),
                _vm.visibleFields.includes("additionalCosts") &&
                _vm.propertiesWithAdditionalCosts.length
                  ? [
                      _vm._l(_vm.propertiesWithAdditionalCosts, function(
                        property
                      ) {
                        return [
                          _c(
                            "dt",
                            {
                              key: "property-name-" + property.propertyId,
                              staticClass: "font-weight-bold"
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(property.name) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _c(
                            "dd",
                            {
                              key: "property-price-" + property.propertyId,
                              staticClass: "font-weight-bold"
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm._f("currency")(property.price)) +
                                  "\n                        "
                              )
                            ]
                          )
                        ]
                      })
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.visibleFields.includes("totalSumGross")
                  ? [
                      _c(
                        "dt",
                        { class: { "font-weight-bold": !_vm.showNetPrices } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$translate("Ceres::Template.basketTotalSum")
                              ) +
                              " " +
                              _vm._s(
                                _vm.$translate("Ceres::Template.basketGross")
                              ) +
                              "\n                    "
                          )
                        ]
                      ),
                      _c(
                        "dd",
                        {
                          class: { "font-weight-bold": !_vm.showNetPrices },
                          attrs: { "data-testing": "basket-amount" }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm._f("currency")(_vm.basket.basketAmount)
                              ) +
                              "\n                    "
                          )
                        ]
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.visibleFields.includes("salesCoupon") &&
                _vm.basket.couponCode &&
                _vm.basket.couponCampaignType === "sales"
                  ? [
                      _c("dt", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$translate("Ceres::Template.basketCoupon")
                            ) +
                            "\n                    "
                        )
                      ]),
                      _c(
                        "dd",
                        {
                          staticClass: "font-weight-bold",
                          attrs: { "data-testing": "sales-coupon" }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm._f("currency")(_vm.basket.couponDiscount)
                              ) +
                              "\n                    "
                          )
                        ]
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.visibleFields.includes("openAmount") &&
                _vm.basket.couponCampaignType === "sales"
                  ? [
                      _c("dt", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$translate("Ceres::Template.basketOpenAmount")
                            ) +
                            "\n                    "
                        )
                      ]),
                      _c(
                        "dd",
                        {
                          staticClass: "font-weight-bold",
                          attrs: { "data-testing": "open-amount" }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm._f("currency")(_vm.basket.openAmount)
                              ) +
                              "\n                    "
                          )
                        ]
                      )
                    ]
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _vm._t("after-total-sum")
          ],
          2
        )
      ]
    ),
    _vm._v(" "),
    _vm.basket.isExportDelivery && _vm.deliveryExportTranslation
      ? _c("div", { staticClass: "alert alert-info w-100" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.deliveryExportTranslation) + "\n    "
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }